<template>
    <section class="sub_page_con wrap_1120 mypage_apply">
        <div class="search_wrap">
            <input type="text" v-model="state.searchText" @keyup.enter="getSearch" @keyup="getSearch" placeholder="검색어를 입력하세요." />
            <button class="search_btn icon_wrap" @click="getSearch"><img src="img/search_btn.png" alt="" /></button>
        </div>
        <div v-if="!state.isMobile" class="btn_wrap _default float_right _board_type">
            <button class="common_btn _gray" @click="isDelete">삭제</button>
        </div>

        <div class="list_table con_board sub_page_con_view applyLIst">
            <ul>
                <li class="thead_li">
                    <div class="tr_div con_tit">
                        <div class="tb_chk checkbox_wrap2">
                            <input type="checkbox" v-model="state.checkAll" @change="toggleAll()" />
                            <em></em>
                        </div>
                        <div class="tb_no D_only">번호</div>
                        <div class="tb_board">게시판</div>
                        <div class="tb_subject">제목</div>
                        <div class="tb_activity_date">활동기간</div>
                        <div class="tb_condition">상태</div>
                        <div class="tb_condition">결과</div>
                        <div class="tb_date_hour">신청날짜</div>
                        <div class="tb_edit_btn">수정</div>
                    </div>
                </li>

                <li class="tbody_li active" v-for="(item, index) in state.list" :key="index" v-if="state.list.length > 0">
                    <template v-if="!state.isMobile">
                        <div class="tr_div con_tit">
                            <div class="tb_chk checkbox_wrap2">
                                <input
                                    type="checkbox"
                                    name="chk"
                                    :value="item.idx"
                                    v-model="state.checkedList"
                                    @click="toggle(item)"
                                    :disabled="item.boardVO.state !== 2 || item.state === 2"
                                />
                            </div>
                            <div class="tb_no D_only">{{ (state.page - 1) * state.size + (index + 1) }}</div>
                            <div class="tb_board">
                                <span v-if="item.boardVO.type === 1">반성매매 시민활동</span>
                                <span v-else-if="item.boardVO.type === 2">캠페인·이벤트</span>
                            </div>
                            <div class="tb_subject">
                                <router-link
                                    :to="{ name: item.boardVO.type === 1 ? 'ActivityView' : 'EventView', params: { id: item.boIdx } }"
                                    class="elips_1"
                                >
                                    <u>
                                        {{ item.boardVO.title }}
                                    </u>
                                </router-link>
                            </div>
                            <div class="tb_activity_date">
                                <span class="mo_th">활동기간</span>
                                {{ CommonUtils.dateFormatYY(new Date(item.boardVO.activeStartDate), ".") }}
                                -
                                {{ CommonUtils.dateFormatYY(new Date(item.boardVO.activeStartDate), ".") }}
                            </div>
                            <div class="tb_condition">
                                <span class="mo_th">상태</span>
                                {{ item.boardVO.state === 1 ? "대기" : item.boardVO.state === 2 ? "모집중" : "마감" }}
                            </div>
                            <div class="tb_condition">
                                <span class="mo_th">결과</span>
                                {{ item.state === 2 ? "선정" : "미선정" }}
                            </div>
                            <div class="tb_date_hour">
                                <span class="mo_th">신청날짜</span>
                                {{ CommonUtils.dateFormat(new Date(item.createDate), ".", true) }}
                            </div>
                            <div class="tb_edit_btn">
                                <button class="blue_btn" @click="showAnswer(item)">
                                    {{ item.boardVO.state === 2 && item.state === 1 ? "수정" : "보기" }}
                                </button>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="tr_div con_tit">
                            <div class="_flex _cate _ai_b">
                                <div
                                    class="condition_tag only_768"
                                    :class="item.boardVO.state === 1 || item.boardVO.state === 2 ? '_green' : '_gray'"
                                >
                                    {{ item.boardVO.state === 1 ? "대기" : item.boardVO.state === 2 ? "모집중" : "마감" }}
                                </div>
                                <div class="condition_tag only_768" v-if="item.boardVO.state === 3">
                                    {{ item.state === 2 ? "선정" : "미선정" }}
                                </div>
                                <div class="tb_board">
                                    <span v-if="item.boardVO.type === 1">반성매매 시민활동</span>
                                    <span v-else-if="item.boardVO.type === 2">캠페인·이벤트</span>
                                </div>
                                <div class="_flex p_r_15"></div>
                            </div>
                            <div class="tb_subject">
                                <router-link
                                    :to="{ name: item.boardVO.type === 1 ? 'ActivityView' : 'EventView', params: { id: item.boIdx } }"
                                    class="elips_1"
                                >
                                    <u>
                                        {{ item.boardVO.title }}
                                    </u>
                                </router-link>
                            </div>
                            <div class="_flex _jc_sb _flex_100">
                                <div class="tb_activity_date">
                                    <span class="mo_th">활동기간</span>
                                    {{ CommonUtils.dateFormatYY(new Date(item.boardVO.activeStartDate), ".") }}
                                    -
                                    {{ CommonUtils.dateFormatYY(new Date(item.boardVO.activeStartDate), ".") }}
                                </div>
                                <div class="tb_date_hour">
                                    <span class="mo_th">신청날짜</span>
                                    {{ CommonUtils.dateFormatForMobile(new Date(item.createDate), ".", true) }}
                                </div>
                            </div>

                            <button class="m_option_btn icon_wrap only_768" @click="optionOpen(item)">
                                <img src="img/kebabIcon.png" class="" />
                            </button>
                            <div class="m_option_wrap" v-show="state.isShowBtn && state.list_idx === item.idx">
                                <button type="button" @click="showAnswer(item)">
                                    {{ item.boardVO.state === 2 && item.state === 1 ? "수정" : "보기" }}
                                </button>
                                <button type="button" class="_gray" @click="optionClose(item)" v-if="item.boardVO.state < 3">삭제</button>
                            </div>
                        </div>
                    </template>
                </li>
                <li v-else class="tbody_li no_data">
                    <div class="tr_div">
                        <div class="tb_subject" style="text-align: center; width: 100%">등록된 게시물이 없습니다.</div>
                    </div>
                </li>
            </ul>
        </div>

        <PageBtn
            v-if="state.list.length !== 0"
            :currentPage="state.page"
            :totalLength="state.totalLength"
            :perPage="state.size"
            @onPaging="handlePageChange"
        ></PageBtn>
        <ModalDefault
            v-if="state.isShowModal"
            :type="state.modalTab"
            :title="state.modalTitle"
            :content="state.modalContent"
            :textarea1="state.textarea1"
            :textarea2="state.textarea2"
            :isAgree="state.isAgree"
            :isPossible="state.isPossible"
            @close="closeModal"
            @callback="callBackModal"
        ></ModalDefault>
    </section>

    <PaperListModal
        v-if="state.isShowAnswer"
        :answerInfo="state.answerInfo"
        :isPossible="state.isPossible"
        @close="state.isShowAnswer = false"
        @callback="
            state.isShowAnswer = false;
            getApplyList();
        "
    ></PaperListModal>
</template>
<script lang="ts" config>
    import {
        Header,
        Footer,
        router,
        ref,
        apiService,
        types,
        reactive,
        onMounted,
        CommonUtils,
        computed,
        ModalDefault,
        watch,
        PageBtn,
        getMessageByCode,
        PaperListModal,
    } from "@/BaseComponent";

    export default {
        components: { Header, Footer, ModalDefault, PageBtn, PaperListModal },
        emits: ["write"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                page: 1 as number,
                size: 10 as number,
                totalPage: 1 as number,
                totalLength: 0 as number,

                list: [] as Array<types.ResBoardApplyVOForApi>,

                checkedList: [] as Array<number>,

                isShowModal: false as boolean,
                modalTab: -1 as number,
                idx: 0 as number,
                modalIsResult: false as boolean,
                modalTitle: "alert" as string,
                modalContent: "" as string,
                textarea1: "" as string,
                textarea2: "" as string,
                isAgree: false as boolean,

                checkAll: false as boolean,
                searchText: "" as string,
                isPossible: false as boolean,

                isMobile: false,
                isShowBtn: false,
                list_idx: 0 as number,

                isShowAnswer: false as boolean,
                answerInfo: {} as any,
            });

            onMounted(() => {
                getApplyList();

                state.isMobile = window.innerWidth < 768;
            });

            watch(
                () => state.checkedList,
                (newVal) => {
                    if (state.checkedList.length !== 0) {
                        state.checkAll = newVal.length === state.list.filter((item) => item.state !== 2 && item.boardVO.state === 2).length;
                    } else {
                        state.checkAll = false;
                    }
                },
            );

            const getApplyList = async () => {
                const param: types.ReqCommonPaging = {
                    page: state.page,
                    size: state.size,
                    searchType: null,
                    searchText: state.searchText,
                };

                const res = await apiService.mypage.applyList(param);

                if (res.returnCode === 0) {
                    state.list = res.list.data;

                    state.totalPage = res.list.totalPages;
                    state.totalLength = res.list.recordsTotal;
                } else if (res.returnCode === 11) {
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "예외 발생";
                    state.modalContent = getMessageByCode(res.returnCode);
                    state.isShowModal = true;
                }
            };

            const closeModal = () => {
                state.isShowModal = false;
            };

            const callBackModal = async (param: any) => {
                if (param.action === "confirm") {
                    deleteCheckList();
                }
            };

            const toggleAll = () => {
                if (state.checkAll) {
                    state.checkedList = state.list.filter((item) => item.state !== 2 && item.boardVO.state === 2).map((item) => item.idx);
                } else {
                    state.checkedList = [];
                }
            };

            const toggle = (item: any) => {
                if (state.checkedList.includes(item.idx)) state.checkedList.splice(state.checkedList.indexOf(item.idx), 1);
                else {
                    if (item.boardVO.state !== 2 || item.state === 2) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "선택한 항목은 삭제할 수 없습니다.";
                        state.isShowModal = true;
                        return;
                    } else {
                        state.checkedList.push(item.idx);
                    }
                }
            };

            const handlePageChange = (page: number) => {
                state.page = page;
                getApplyList();
            };
            const getSearch = () => {
                state.page = 1;
                getApplyList();
            };

            const showAnswer = (item: any) => {
                state.answerInfo = item;
                state.answerInfo.name = item.memberVO.memberVO.name;
                state.isShowAnswer = true;
                state.isPossible = item.boardVO.state === 2 && item.state === 1;
            };

            const isDelete = () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    state.modalTab = 5;
                    state.modalTitle = "알림";
                    state.modalContent = "정말 삭제하시겠습니까?";
                    state.isShowModal = true;
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };

            const deleteCheckList = async () => {
                if (state.checkedList && state.checkedList.length > 0) {
                    const res = await apiService.mypage.applyListMultiRemove(state.checkedList.join(","));
                    if (res.returnCode === 0) {
                        state.modalTab = -1;
                        state.modalTitle = "알림";
                        state.modalContent = "삭제가 완료되었습니다.";
                        state.isShowModal = true;

                        getApplyList();
                        state.checkedList = [];
                    } else if (res.returnCode === 11) {
                    } else {
                        state.modalTab = -1;
                        state.modalTitle = "예외 발생";
                        state.modalContent = getMessageByCode(res.returnCode);
                        state.isShowModal = true;
                    }
                } else {
                    state.modalTab = -1;
                    state.modalTitle = "알림";
                    state.modalContent = "선택된 게시글이 없습니다.";
                    state.isShowModal = true;
                }
            };
            const optionOpen = (item: any) => {
                if (state.list_idx === item.idx) {
                    state.isShowBtn = false;
                    state.list_idx = 0;
                } else {
                    state.isShowBtn = true;
                    state.list_idx = item.idx;
                }
            };

            const optionClose = (item: any) => {
                state.checkedList = [item.idx];

                isDelete();
            };

            return {
                state,
                CommonUtils,
                closeModal,
                callBackModal,
                handlePageChange,
                toggleAll,
                getSearch,
                showAnswer,
                isDelete,
                toggle,
                optionOpen,
                optionClose,
                getApplyList,
            };
        },
    };
</script>

<style scoped>
    .checkbox_wrap2 input[type="checkbox"] {
        appearance: auto;
        -webkit-appearance: auto;
        -moz-appearance: auto;
        display: inline-block;
        width: 22px;
        height: 22px;
        background-color: #fff;
        position: relative;
        vertical-align: sub;
        cursor: pointer;
        border: 1px solid #6d6d6d;
    }
    .checkbox_wrap2 em {
        display: none;
    }
</style>
